export default __webpack_public_path__ + "images/cb6ab352ec8efbcda61480e0bf39d914-public_speaker_small.webp";